import { BaseModalViewModel } from '../../../../models/base/base-modal-view-model';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InternalUsersDomainModel } from '../../../../domainModels/internal-users-domain-model.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ChangeEmailRequest } from '../../../../models/users/requests/change-email-request';
import { InternalUser } from '../../../../models/users/dto/internal-user';
import { map, switchMap } from 'rxjs/operators';
import { CustomError } from '../../../../models/shared/custom-error';
import { ToastService } from '../../../../services/toast-service';
import { EmployersDomainModel } from '../../../../domainModels/employers-domain-model';
import { BaseUser } from '../../../../models/base/base-user';
import { EmployerUser } from '../../../../models/users/dto/employer-user';
import { MemberUser } from '../../../../models/users/dto/member-user';
import _default from 'chart.js/dist/core/core.layouts';
import update = _default.update;
import { MembersDomainModel } from '../../../../domainModels/members-domain-model';

@Injectable()
export class ChangeUserEmailModalViewModel extends BaseModalViewModel {
  constructor(
    public router: Router,
    public ngbModal: NgbModal,
    private internalUserDomainModel: InternalUsersDomainModel,
    private employerDomainModel: EmployersDomainModel,
    private memberDomainModel: MembersDomainModel,
    private toastService: ToastService
  ) {
    super(router, ngbModal);
  }

  public changeEmailReq$ = of(new ChangeEmailRequest());

  private _user = new BehaviorSubject<any>({} as InternalUser);
  public readonly user$ = this._user as Observable<EmployerUser | MemberUser | InternalUser>;

  public flowText$ = this.user$.pipe(
    map(a => {
      return $localize`Change the email address that ${a?.fullName} will use to login.`;
    })
  );

  public setUser<T extends BaseUser>(user: T): void {
    this._user.next(user);
  }

  public formSubmitted(req: ChangeEmailRequest) {
    const lm = $localize`Changing Email`;
    this.user$
      .pipe(
        switchMap(user => {
          if (!!user) {
            this._loadingOpts.addRequest(lm);
            return this.getChangeEmailRoute(user, req);
          } else {
            return of(null);
          }
        })
      )
      .subscribe({
        next: (updatedUser: BaseUser | null) => {
          if (updatedUser) {
            this.toastService.publishSuccessMessage($localize`Success!`, $localize`Email Changed!`);
            this._loadingOpts.removeRequest(lm);
            this.closeWithReturnValue(updatedUser);
          } else {
            this._loadingOpts.removeRequest(lm);
            this.toastService.publishErrorMessage($localize`Error`, $localize`Failed to change email`);
            this.closeModal();
          }
        },
        error: (err: CustomError) => {
          this._loadingOpts.removeRequest(lm);
          this.toastService.publishError(err);
          this.closeModal();
        },
        complete: () => this._loadingOpts.removeRequest(lm)
      });
  }

  private getChangeEmailRoute(user: BaseUser, req: ChangeEmailRequest): Observable<BaseUser | null> {
    if (user instanceof InternalUser) {
      return this.internalUserDomainModel.forceResetInternalUserEmail(req, user.id.toString(10));
    } else if (user instanceof EmployerUser) {
      return this.employerDomainModel.forceChangeEmail(req, user);
    } else if (user instanceof MemberUser) {
      return this.memberDomainModel.forceChangeEmail(req, user?.id);
    } else {
      return of(null);
    }
  }
}
